import { render, staticRenderFns } from "./DemoLb.vue?vue&type=template&id=0d34833b&scoped=true&"
import script from "./DemoLb.vue?vue&type=script&lang=js&"
export * from "./DemoLb.vue?vue&type=script&lang=js&"
import style0 from "./DemoLb.vue?vue&type=style&index=0&id=0d34833b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d34833b",
  null
  
)

export default component.exports